import React from 'react';

let prevVal;
const validate = (e, callBack) => {
    const target = e.target;
    let value = parseInt(target.value, 10);
    const min = parseInt(target.min, 10);
    const max = parseInt(target.max, 10);
    const defaultValue = parseInt(e._targetInst.memoizedProps.defaultValue, 10);

    if ((value < min) || (value > max)) {
        target.value = prevVal || defaultValue;
    } else {
        target.value = value;
    }

    if (typeof callBack === 'function') {
        callBack(e);
    }

    prevVal = target.value;
};

const Number = ({title, name, minValue, maxValue, disabled, value, onChange}) => (
    <div className="fieldWrapper">
        <label htmlFor={name}>
            {title || name}:
        </label>
        <input
            id={name}
            name={name}
            type="number"
            readOnly={disabled}
            defaultValue={value}
            onChange={(e)=>{validate(e, onChange)}}
            max={maxValue}
            min={minValue}
        />
    </div>
);


export default Number;
